import axios from '@/_services/axios';

export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    username: localStorage.getItem('username') || '',
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    username: state => state.username,
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, result) {
      state.status = 'success';
      state.token = result.token;
      state.username = result.username;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
    },
  },
  actions: {
    login({ dispatch, commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');

        axios
          .post('login', user, {
            headers: { 'Content-Type': 'application/json' },
          })
          .then(resp => {
            const token = resp.data.token;
            const username = resp.data.userName;

            localStorage.setItem('token', token);
            localStorage.setItem('username', username);

            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            commit('auth_success', { token, username });

            dispatch('user/user', username, { root: true }).then(() => {
              resolve(resp);
            });
          })
          .catch(err => {
            commit('auth_error');
            cleanStore();
            reject(err);
          });
      });
    },
    logout({ dispatch, commit }) {
      return new Promise(resolve => {
        commit('logout');
        cleanStore();
        dispatch('user/logout', {}, { root: true });
        resolve();
      });
    },
  },
};

function cleanStore() {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  delete axios.defaults.headers.common['Authorization'];
}
